
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { FloatingContactForm } from "./FloatingContactForm";

interface FloatingContactButtonProps {
  serviceName?: string;
}

export const FloatingContactButton = ({ serviceName }: FloatingContactButtonProps) => {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const toggleForm = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <>
      {!isFormVisible && (
        <Button
          onClick={toggleForm}
          className="fixed bottom-4 right-4 z-50 bg-primary hover:bg-primary/90 text-white shadow-lg flex items-center gap-2"
        >
          <MessageSquare className="h-4 w-4" />
          <span>Contact Us</span>
        </Button>
      )}
      
      {isFormVisible && (
        <FloatingContactForm 
          serviceName={serviceName} 
          onClose={() => setIsFormVisible(false)} 
        />
      )}
    </>
  );
};
